import type { LoaderFunctionArgs } from 'react-router';

import type { QueryClient } from '@tanstack/react-query';

import { enterpriseApi } from '@/common/enterprise-api';
import { createTemplateQuery } from '@/utilities/queries/create-template-query';

/**
 * Creates a loader function for fetching template data using React Query.
 *
 * @param queryClient - The QueryClient instance used to manage and cache queries.
 * @returns A loader function compatible with React Router that retrieves template data
 *          based on the `suppressionName` route parameter.
 */
export const templateLoader = (queryClient: QueryClient) => {
  return async ({ params: { suppressionName: name } }: LoaderFunctionArgs) => {
    const data = await queryClient.ensureQueryData(createTemplateQuery(enterpriseApi, { name }));

    if (data.failure) {
      return null;
    }

    return data.data;
  };
};
